var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"FilmCount-Cloud",staticStyle:{"height":"20vh","width":"90vw","margin":"0 auto"}},[_c('svg',{attrs:{"id":"FilmCountCloud","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }